import React from 'react';
import { Typography, Box, Button, Modal, } from '@mui/material';
import { useTheme } from '../../contexts/ThemeContext';


const ErrorModal = (props) => {
  const { theme } = useTheme();

  return (
    <Modal open={props.open} onClose={() => props.setOpen(false)}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          // width: '26vw',
          bgcolor: theme.background.primary,
          borderRadius: 2,
          border: `4px solid ${theme.color.primary}`,
          boxShadow: 24,
          p: 4,
          outline: 'none',
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom style={{ fontFamily: theme.fontFamily, textAlign: 'center', color: theme.text.primary }}>
          {props.message}
        </Typography>

        {/* Cancel button */}
        <Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 3 }}>
          <Button variant="contained" onClick={() => props.setOpen(false)} style={{
            textTransform: 'none',
            fontFamily: theme.fontFamily,
            color: theme.text.negative,
            borderRadius: '20px',
            backgroundColor: theme.accent.success,
            border: `1px solid ${theme.border.light}`
          }} >
            OK
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ErrorModal;